var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2707_740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2707_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0006 36.834C26.6145 36.834 27.1291 36.6263 27.5444 36.2111C27.9597 35.7958 28.1673 35.2812 28.1673 34.6673C28.1673 34.0534 27.9597 33.5388 27.5444 33.1236C27.1291 32.7083 26.6145 32.5006 26.0006 32.5006C25.3868 32.5006 24.8722 32.7083 24.4569 33.1236C24.0416 33.5388 23.834 34.0534 23.834 34.6673C23.834 35.2812 24.0416 35.7958 24.4569 36.2111C24.8722 36.6263 25.3868 36.834 26.0006 36.834ZM23.834 28.1673H28.1673V15.1673H23.834V28.1673ZM26.0006 47.6673C23.0034 47.6673 20.1868 47.0986 17.5506 45.9611C14.9145 44.8236 12.6215 43.2798 10.6715 41.3298C8.72148 39.3798 7.17773 37.0868 6.04023 34.4506C4.90273 31.8145 4.33398 28.9979 4.33398 26.0006C4.33398 23.0034 4.90273 20.1868 6.04023 17.5506C7.17773 14.9145 8.72148 12.6215 10.6715 10.6715C12.6215 8.72148 14.9145 7.17773 17.5506 6.04023C20.1868 4.90273 23.0034 4.33398 26.0006 4.33398C28.9979 4.33398 31.8145 4.90273 34.4506 6.04023C37.0868 7.17773 39.3798 8.72148 41.3298 10.6715C43.2798 12.6215 44.8236 14.9145 45.9611 17.5506C47.0986 20.1868 47.6673 23.0034 47.6673 26.0006C47.6673 28.9979 47.0986 31.8145 45.9611 34.4506C44.8236 37.0868 43.2798 39.3798 41.3298 41.3298C39.3798 43.2798 37.0868 44.8236 34.4506 45.9611C31.8145 47.0986 28.9979 47.6673 26.0006 47.6673Z",
    fill: "#E33B32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e81614d277a15b687e2a44d0144238bd.svg";
export { ForwardRef as ReactComponent };